export default "__VITE_ASSET__BSyEPvee__"